// Vendors
import 'src/scripts/vendor/jquery'
import 'src/scripts/vendor/bootstrap'
import jQuery from "jquery";
import ModulePreloader from "src/scripts/modules/modulePreloader";
import Register from "src/scripts/pages/register";
import Home from "src/scripts/pages/home";
import Textpage from "src/scripts/pages/textpage";

jQuery(document).ready(function () {
  let pageName = jQuery('body').data('page');

  const modulePreloader = new ModulePreloader();
  modulePreloader.init();

  setTimeout(function () {

    if(pageName == "home") {
      const home = new Home();
      home.init();
    }
    else if(pageName == "register") {
      const register = new Register();
      register.init();
    }
    else if(pageName == "text") {
      const textpage = new Textpage();
      textpage.init();
    }
  }, 100);
});
